// communication to sanity.io

// Basic imports
import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "2h13hnwp",
    dataset: "personalsite"
})